import { render, staticRenderFns } from "./LandingAbout.vue?vue&type=template&id=1aec1a25"
import script from "./LandingAbout.vue?vue&type=script&lang=ts"
export * from "./LandingAbout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports